import DOMPurify from 'dompurify';

// Sanitizes SVG markup before it is injected with dangerouslySetInnerHTML.
export const sanitizeSvg = (svg) => {
  if (!svg) return '';
  return DOMPurify.sanitize(svg, {
    USE_PROFILES: { svg: true, svgFilters: true },
    ADD_TAGS: ['use'],
    ADD_ATTR: ['xlink:href', 'href', 'data-color', 'data-id', 'data-name', 'viewBox', 'preserveAspectRatio'],
    FORBID_TAGS: ['script', 'foreignObject'],
    FORBID_ATTR: ['onload', 'onclick', 'onerror', 'onmouseover'],
  });
};
